<script setup>

const props = defineProps({
  title: {
    type: String,
  },
	color: {
    type: String,
  },
	box: {
		type: Object
	},
	boxImage: {
    type: String,
		default: 'left'
  },
	items: {
		type: Array
	},
	levels: {
		type: Object
	},
	specific: {
    type: String,
  },
	perex: {
    type: String,
  },
})

const getColor = () => {
	switch (props.specific) {
		case 'Distribution':
			return 'gold'
		case 'RecordDeal':
			return 'cyan'
		case 'ExclusiveDeal':
			return 'magenta'
		default:
			return "red"
	}
}

const { $listen } = useNuxtApp()

$listen('slideToCategory', (category) => {
	if(props.specific === category[0]) {
		divs?.value[category[1]].scrollIntoView({ behavior: 'smooth' })
	}
})

const divs = ref([])

onBeforeUpdate(() => {
	divs.value = []
})

</script>

<template>

	<div>
		<h2 class="text-center mb-14" :class="[`text-${getColor()}`, perex ? `mb-5` : 'mb-8 md:mb-14']">{{ title }}</h2>

		<ClientOnly>
			<div v-if="perex" class="mb-8 md:mb-14 text-xl md:text-2xl dark:text-light text-center" v-html="perex"></div>
		</ClientOnly>

		<div v-if="levels" class="xl:grid grid-cols-12 gap-8 mb-10 xl:mb-20">
			<div class="col-span-10 col-start-2">
				<div class="flex flex-col lg:flex-row gap-2">
					<div
						v-for="(item, index) in levels.items"
						:key="index"
						class="flex-1"
					>
						<div class="p-8 dark:text-light dark:bg-dark8 bg-lightBg8 h-full">
							<h5 class="dark:text-light mb-4">{{ item.title }}</h5>
							<ClientOnly>
								<p v-html="item.description"></p>
							</ClientOnly>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div v-for="(item, index) in items" :key="index" :ref="el => { divs[index] = el }" class="mb-8 xl:mb-14 xl:text-center max-w-[870px] mx-auto">
			<h4 class="mb-5 dark:text-light text-dark">{{ item.title }}</h4>
			<ClientOnly>
				<p class="dark:text-light text-dark text-base xl:text-lg" v-html="item.description" />
			</ClientOnly>
		</div>

		<ClientOnly>
			<ImageBox class="mb-24" :box-image="boxImage" :image="box.image" :text="box.text" :author="box.author" :color="getColor()" />
		</ClientOnly>

	</div>

</template>